
export const getRegion = state => state.dropDown.region;
export const getDropDown = state => state.dropDown;
export const getUserProfile = state => state.profile.profile;
export const getApiAlert = state => state.common.apiAlert;
export const getSelectedAgency = state => state.dropDown.selectedAgency;
